import { useState } from 'react'
import { t } from 'ttag'
import { Link } from 'react-router-dom'

import { Button } from '@h2/components/buttons/button'
import { Modal } from '@h2/components/containers/modal'
import { Heading } from '@h2/components/typography/heading'
import { Grid } from '@h2/components/containers/grid'
import { DESC } from '@h2/components/containers/grid/constants'

const MajorListing = ({ majors }) => {
  const [modalShown, setModalShown] = useState(false)
  const showModal = () => setModalShown(true)
  const hideModal = () => setModalShown(false)
  const profs = [...majors]
    .sort((majorA, majorB) => {
      return majorB.undergradCompletions - majorA.undergradCompletions
    })
    .filter(major => !major.rollUp && major.title && major.totalCompletions > 0)
  const profs2 = profs.length > 25 ? profs.slice(0, 25) : profs
  const columns = [
    {
      id: 'title',
      sortable: true,
      width: '60%',
      label: t`Program Title`,
      render({ url, title }) {
        return <Link to={url}>{title}</Link>
      }
    },
    {
      id: 'undergradCompletions',
      sortable: true,
      label: t`Undergraduate Completers`
    },
    {
      id: 'gradCompletions',
      sortable: true,
      label: t`Graduate Completers`
    }
  ]

  return (
    <div>
      <ul>
        {profs2.map((major, idx) => (
          <li key={`major-${idx}`}>
            <Link to={major.url}>{major.title}</Link>
          </li>
        ))}
      </ul>
      <Button onClick={showModal}>{t`View All`}</Button>
      <Modal isOpen={modalShown} closeOnClickOverlay={true} onClose={hideModal}>
        <Modal.Header closeButton>
          <Heading level="2">{t`Majors Offered`}</Heading>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '80vh', overflow: 'scroll' }}>
          {profs.length === 0 ? null : (
            <Grid
              columns={columns}
              data={profs}
              options={{ disableFilters: true, fullWidth: true }}
              rowIdKey="title"
              defaultSortBy="undergradCompletions"
              defaultSortOrder={DESC}
              isPagerVisible={true}
              isRowSelectable={false}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  )
}

export { MajorListing }
